__turbopack_context__.v({
  "Axes": "Loading-module__Q6iE3a__Axes",
  "ChartBar": "Loading-module__Q6iE3a__ChartBar",
  "ChartWrap": "Loading-module__Q6iE3a__ChartWrap",
  "LoaderDot": "Loading-module__Q6iE3a__LoaderDot",
  "LoaderDotSmall": "Loading-module__Q6iE3a__LoaderDotSmall",
  "Wrap": "Loading-module__Q6iE3a__Wrap",
  "animate": "Loading-module__Q6iE3a__animate",
  "appear": "Loading-module__Q6iE3a__appear",
  "growBar": "Loading-module__Q6iE3a__growBar",
});
